var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.6988 12.0002L24.0439 2.65458C24.652 2.04669 24.652 1.06381 24.0439 0.455919C23.436 -0.151973 22.4531 -0.151973 21.8453 0.455919L12.4999 9.80152L3.15474 0.455919C2.54658 -0.151973 1.564 -0.151973 0.956123 0.455919C0.347959 1.06381 0.347959 2.04669 0.956123 2.65458L10.3012 12.0002L0.956123 21.3458C0.347959 21.9537 0.347959 22.9365 0.956123 23.5444C1.25907 23.8477 1.65739 24 2.05543 24C2.45347 24 2.85151 23.8477 3.15474 23.5444L12.4999 14.1988L21.8453 23.5444C22.1485 23.8477 22.5465 24 22.9446 24C23.3426 24 23.7406 23.8477 24.0439 23.5444C24.652 22.9365 24.652 21.9537 24.0439 21.3458L14.6988 12.0002Z",
    fill: "#E26564"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNo);
export default __webpack_public_path__ + "static/media/no.f116e894e0420c2f8a84e4938a04d32e.svg";
export { ForwardRef as ReactComponent };